/**
 * @file AddNewAdminDialogTheme.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { createCustomTheme } from "../../../utils/theme/CommonTheme";

/**
 * Creates new admin title theme
 */
export const NewAdminTitle = createCustomTheme(700, 26, true);

export const Steps = createCustomTheme(700, 20, true);

export const StepsDetails = createCustomTheme(400, 20, true);

/**
 * Creates new admin sub title theme
 */
export const AdminSubTitle =  createCustomTheme(500, 12);

/**
 * Creates Identitier theme
 */
export const Identitier = createCustomTheme(700, 12);

/**
 * Creates Admin User button theme
 */
export const AdminAddUserButton = createCustomTheme(700, 16, true);

/**
 * Creates Clinic button theme
 */
export const  NewClinicButton = createCustomTheme(700, 15, true);
/**
 * Creates Consent button theme
 */
export const  ConsentButton = createCustomTheme(700, 13, true);
/**
 * Creates Generate buton theme
 */
export const GenerateButton = createCustomTheme(700, 18, true);

/**
 * Creates Delete Dialog button theme
 */
export const  DeleteDialogButton = createCustomTheme(700, 16, true);